<template>
    <rkm-overlay>
        <rkm-layout-body title="Confirmação de Coletas">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-laboratorial/confirmacao-coleta/List'

export default {
    components: { List },
}
</script>
